import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {Culture, Service, SEPARATOR_SELECT, Timezone} from '../../..';
import {Observable, Subscription} from 'rxjs';
import {Config} from '../../../models/config';
import {Country} from '../../../models/country';
import {Product} from '../../../models/product';
import {Device} from '../../../models/device';
import {ServerForm, ServerFormUrl} from '../../../models/servers';
import {SimpleObject} from '../../../models/simple-object';
import {UpdateDynamicFormService} from '../../../services/update-dynamic-form.service';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import * as _ from 'lodash';

@Component({
  selector: 'storever-form-multiselect',
  templateUrl: './form-multiselect.component.html',
  styleUrls: ['./form-multiselect.component.scss']
})
export class FormMultiselectComponent implements OnInit {
  config: Config;
  group: FormGroup;
  // tslint:disable-next-line:no-any
  datas: any[];
  isEdit: boolean;
  separator = SEPARATOR_SELECT;
  controlName = null;
  showWarning: boolean;
  toggleElements = true;
  private sub$: Subscription;
  private subscriptions = [];

  get isEnabled(): boolean {
    return this.group.disabled;
  }

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private updateDynamicFormService: UpdateDynamicFormService,
              private cdr: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    if (this.config && this.config.options && this.group) {
      if (this.config.options.toggle === false && this.config.options.toggle !== undefined) {
        this.toggleElements = false;
      }
      if (this.config.options.toggle === undefined) {
        this.toggleElements = true;
      }
    }

  }
  /**
   * cette fonction update le bon boolean pour le bon contrôleur et pour le bon type
   * Actuellement il n'y a que deux types le triangle de warning et type toggle qui permet de cacher/afficher un element
   * @param le nom du controller actuelle
   *
   */

  get getControlName(): AbstractControl {
    return this.group.get(this.config.controlName[0]);
  }
  get getControlNameSub(): AbstractControl {
    return this.group.get(this.config.controlName[0]);
  }
    // tslint:disable-next-line:no-any
  isValueInControl(optionValue: any, controlValue: string): boolean {
    if (!controlValue) { return false; }
    return controlValue.includes(optionValue);
  }
}
